import React from 'react';

const MessageBlock = ({ message, iconClass, messageClass, blockClass = "" }) => {
  return (
    <div className={`w-full h-[calc(100vh-200px)] flex flex-col items-center justify-center space-y-4 ${blockClass}`}>
      <div className={`text-xl font-medium ${messageClass}`}>
        {message}
      </div>
      <i className={`fas fa-2x ${iconClass}`}></i>
    </div>
  );
};

export default MessageBlock;
